export const ID_CODE_BY_NAME = {
    "SINGAPORE CITIZEN": "SP",
    "SINGAPORE PERMANENT RESIDENT": "SB",
    "FOREIGNER (PASSPORT)": "PP"
};

export const ID_NAMES = Object.keys(ID_CODE_BY_NAME);